/**
 * "SSMS / Azure Data Studio" shortcut scheme (plan D7). Sources, accessed 2026-09-23:
 *
 * [SSMS] https://learn.microsoft.com/en-us/ssms/sql-server-management-studio-keyboard-shortcuts
 *   Microsoft Learn, "SQL Server Management Studio keyboard shortcuts" (ms.date 2025-10-30),
 *   Query/Editor table: F5 "Run the selected portion of the query editor or the entire query
 *   editor if nothing is selected", Alt+Break "Cancel the executing query", Ctrl+R "Show or
 *   hide the query results pane".
 * [KEYMAP] https://learn.microsoft.com/en-us/sql/tools/visual-studio-code-extensions/mssql/mssql-keyboard-shortcuts
 *   Microsoft Learn, "Customize keyboard shortcuts" (ms.date 2026-07-10), table of the "MSSQL
 *   Database Management Keymap" — Microsoft's keymap for "familiar Azure Data Studio or
 *   SSMS-style shortcuts", with Windows/Linux and macOS columns: Run query F5 / F5, Cancel
 *   running query Alt+Pause/Break / Option+Pause/Break. Cross-checked with its manifest,
 *   github.com/microsoft/vscode-mssql extensions/database-management-keymap/package.json
 *   (0.1.2): mssql.runQuery f5 (mac f5), mssql.cancelQuery alt+pausebreak.
 *
 * Platforms: SSMS is Windows-only, and Azure Data Studio's own keyboard-shortcuts page
 * (learn.microsoft.com/en-us/previous-versions/azure-data-studio/keyboard-shortcuts) lists no
 * chords, so macOS uses the [KEYMAP] macOS column where it has the command and the key exists
 * on a Mac; Linux repeats the Windows chords, as the [KEYMAP] table has one Windows/Linux
 * column. Alt+Break is the Pause key with Alt, the `Pause` token (D5).
 *
 * Mapping: F5 is already the Jam Execute default, so it needs no row.
 *
 * Left out: Ctrl+E and Alt+X (not in the current [SSMS] reference); Shift+Enter ([SSMS]:
 * "Insert a new line" — the Jam Execute current statement default stays); Ctrl+F5 ([SSMS]:
 * parse; the [KEYMAP] "Run current statement", Cmd+F5 on macOS — two meanings); Ctrl+N and
 * Ctrl+Shift+R (already the Jam defaults for New Query and Refresh IntelliSense).
 */
import { defineScheme, onWindowsAndLinux } from './schemeRows';

export const ssmsAds = defineScheme('ssms-ads', 'SSMS / Azure Data Studio', [
  // [SSMS] Alt+Break. No macOS row: [KEYMAP] lists Option+Pause/Break, but Chromium maps no
  // macOS key to the DOM code "Pause" — its table has 0xffff in the Mac column
  // (https://source.chromium.org/chromium/chromium/src/+/main:ui/events/keycodes/dom/dom_code_data.inc,
  // DOM_CODE(0x070048, 0x0077, 0x007f, 0x0045, 0xffff, "Pause", PAUSE)) and Mac keyboards have no
  // Pause key, so the chord could never fire. macOS keeps the Jam default (Cancel unbound).
  { commandId: 'query.cancel', chords: onWindowsAndLinux('Alt+Pause') },
  // [SSMS] Ctrl+R. No documented macOS chord: the [KEYMAP] row "Show query results pane" reads
  // Win+Shift+R / Cmd+Shift+R while its manifest binds ctrl+shift+r everywhere, and Cmd+Shift+R
  // is Jam's Refresh IntelliSense — macOS keeps the Jam default.
  { commandId: 'query.toggleResults', chords: onWindowsAndLinux('Ctrl+R') },
]);
